/**
 * 2단계: content에 ___가 있는 라인 수만큼 lineAnswers가 모두 공백이 아닌지 검사
 * @param {Array<{ content?: string, lineAnswers?: string[] }>} step2Files
 * @returns {boolean} 모두 채워졌으면 true
 */
export function areStep2BlankLineAnswersFilled(step2Files) {
    if (!Array.isArray(step2Files)) return true;
    for (const file of step2Files) {
        const content = file?.content || '';
        const blankCount = content.split('\n').filter((line) => line.includes('___')).length;
        if (blankCount === 0) continue;
        const answers = Array.isArray(file.lineAnswers) ? file.lineAnswers : [];
        for (let i = 0; i < blankCount; i += 1) {
            if (String(answers[i] ?? '').trim() === '') {
                return false;
            }
        }
    }
    return true;
}
